function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

import React, { useEffect, useState } from 'react';
import shuffle from 'lodash/shuffle';
import { Flipper, Flipped } from 'react-flip-toolkit';
import { Wrapper, WidgetIcons, WidgetIcon } from './ReportLoadingState.styles';
import { useInterval } from '@signal/core-hooks/useInterval';
var widgetIconArray = [1, 2, 3, 4, 5, 6, 7, 8, 9];
var springOptions = {
  stiffness: 750,
  damping: 100
};
export var ReportLoadingState = function ReportLoadingState() {
  var _useState = useState(widgetIconArray),
      _useState2 = _slicedToArray(_useState, 2),
      widgetArray = _useState2[0],
      setWidgetArray = _useState2[1]; // Fire animation once immediately. This improves the UX by providing immediate
  // feedback that this is a loading state.


  useEffect(function () {
    return setWidgetArray(function (widgetArray) {
      return shuffle(widgetArray);
    });
  }, []); // Fire animation every 1500ms

  useInterval(function () {
    return setWidgetArray(function (widgetArray) {
      return shuffle(widgetArray);
    });
  }, 1500);
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Flipper, {
    flipKey: widgetArray.join(''),
    spring: springOptions
  }, /*#__PURE__*/React.createElement(WidgetIcons, null, widgetArray.map(function (id) {
    return /*#__PURE__*/React.createElement(Flipped, {
      flipId: id,
      key: id
    }, /*#__PURE__*/React.createElement(WidgetIcon, {
      key: id
    }));
  }))));
};